import {getReplaceText} from "./get-replace-text";
import {eventPlaces} from "./event-place";

export const getEventPlaceUrl = (path, eventPlaceId) => {
    const place = eventPlaces.find(place => place.id === eventPlaceId);
    const subdomain = place.id === 1 ? `` : `${ place.eventplace }.`
    const url = new URL(window.location.href);
    return `${ url.protocol }//${ subdomain }${ process.env.REACT_APP_DOMAIN }${ path }`;
}